export default __webpack_public_path__ + "static/media/banksathi.ac5c185f.png";